import { SurveyPageType } from "../../../store/Models/Surveys/SurveyDataModel";
import { InventoryDetailsResponse } from "../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseModels";
import { NavContext } from "../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseStates";
import { IStringLocalizer } from "../../../utilities/IStringLocalizer";
import { ToxnotReactModal, ToxnotReactModalBody } from "../ToxnotReactModal";
import { RedirectLink } from "../RedirectLink";

import "./styles.css";

interface CommonModalEditorProps {
    modalId: string;
    localizer: IStringLocalizer;
    navContext: NavContext | undefined;
    responseId: string;
    selectedInventory: InventoryDetailsResponse | null;
    userId: string;
    handleClickImportMaterial: any;
}

const CommonModalEditor: React.FC<CommonModalEditorProps> = ({ modalId, localizer, navContext, responseId, selectedInventory, userId, handleClickImportMaterial }) => {
    const redirectLinkState = {
        responseId: responseId,
        surveyResponseInventoryId: selectedInventory?.inventoryId
    }
   
    const handleClickImport = () => {
        const id = '#' + modalId;
        $(id).modal("hide");
    };

    return (
        <ToxnotReactModal
            modalId={modalId.toString()}
            customHeader={
                <div>
                    <h4 className="modal-title">{localizer.localizeString("Choose a way to import")}</h4>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            }>
            <ToxnotReactModalBody>
                <div className="start-subcontent-content-container">
                    <div className="selectors-container">
                        {(navContext?.mainNavIndex !== SurveyPageType.SupplierQuestionnaire ?? true) &&
                            <div className="selector-div" onClick={() => window.open(`/Data/NewProduct?responseId=${responseId}&inventoryId=${selectedInventory?.inventoryId}&mode=Component`, "_blank")}>
                                <div className="title">{localizer.localizeString("Excel Spreadsheet")}</div>
                                <div className="description">{localizer.localizeString("Import BOM data via an excel Spreadsheet")}
                                </div>
                            </div>
                        }
                        {(navContext?.mainNavIndex !== SurveyPageType.SupplierQuestionnaire ?? true) &&
                            <div className="selector-div" onClick={() => window.open(`/Data/NewProduct?responseId=${responseId}&inventoryId=${selectedInventory?.inventoryId}&mode=MSDS%20Library`, "_blank")}>
                                <div className="title">{localizer.localizeString("Safety Data Sheet (SDS)")}</div>
                                <div className="description"></div>
                            </div>
                        }
                        <div className="selector-div" onClick={handleClickImportMaterial}>
                            <div className="title">{localizer.localizeString("Select from My Materials")}</div><div className="description">{localizer.localizeString("Import Material")}</div>
                        </div>
                        <RedirectLink 
                            handleClickImport={handleClickImport}
                            state={redirectLinkState}
                            localizer={localizer}
                            pathname={"/Exchange/Management/MyPassports"}>
                        </RedirectLink>
                    </div>
                </div>
            </ToxnotReactModalBody>
        </ToxnotReactModal>
    );
}

export default CommonModalEditor;